import { useCallback, useState } from "react";
import { fetchTemplateData } from "./fetchTemplateData";
import { buildSortedGroups } from "./buildSortedGroups";
import { buildTemplateWorkbook } from "./buildTemplateWorkbook";

const safe = (s) => String(s).replace(/[^a-z0-9-_]+/gi, "_");

const triggerDownload = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  try {
    const a = Object.assign(document.createElement("a"), { href: url, download: fileName });
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } finally {
    URL.revokeObjectURL(url);
  }
};

/**
 * Generates the standard Excel template entirely client-side.
 * Replaces the old POST `quantative-data/excel-template` round-trip.
 */
export const useGenerateExcelTemplate = () => {
  const [loading, setLoading] = useState(false);

  const generate = useCallback(
    async ({ financialYearId, sourceId, periods, companyLabel, fyValue }) => {
      if (!periods?.length) throw new Error("At least one period is required.");
      setLoading(true);
      try {
        const data = await fetchTemplateData({ financialYearId });
        const sortedGroups = buildSortedGroups({ ...data, sourceId });
        const blob = await buildTemplateWorkbook(sortedGroups, periods);
        const fileName = `${safe(companyLabel || `Company_${financialYearId}`)}_Template_${safe(fyValue || `FY${financialYearId}`)}.xlsx`;
        triggerDownload(blob, fileName);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { generate, loading };
};
